
import ProductBrandEditComponent from "../../../components/product_brands/Edit.vue";

export default {
  components: {
    ProductBrandEditComponent
  }
}
